import { v4 as uuid } from 'uuid';
import { ADD_ALERT, REMOVE_ALERT, DEFAULT_ALERT_TIME, ASSERTIVE } from '@instructure/quiz-common';
export function addAlert(_ref) {
  var message = _ref.message,
    variant = _ref.variant,
    _ref$removeIn = _ref.removeIn,
    removeIn = _ref$removeIn === void 0 ? DEFAULT_ALERT_TIME : _ref$removeIn,
    _ref$guid = _ref.guid,
    guid = _ref$guid === void 0 ? uuid() : _ref$guid,
    _ref$politeness = _ref.politeness,
    politeness = _ref$politeness === void 0 ? ASSERTIVE : _ref$politeness;
  return {
    type: ADD_ALERT,
    payload: {
      message: message,
      removeIn: removeIn,
      uuid: guid,
      variant: variant,
      politeness: politeness
    }
  };
}
export function addError(message, removeIn, guid) {
  return addAlert({
    message: message,
    variant: 'error',
    removeIn: removeIn,
    guid: guid
  });
}
export function addStickyError(message, guid) {
  return addAlert({
    message: message,
    variant: 'stickyerror',
    guid: guid
  });
}
export function addSuccess(message) {
  return addAlert({
    message: message,
    variant: 'success'
  });
}
export function addInfo(message) {
  return addAlert({
    message: message,
    variant: 'info'
  });
}
export function screenreaderNotification(message, politeness) {
  var removeIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
  return addAlert({
    message: message,
    variant: 'screenreader',
    removeIn: removeIn,
    politeness: politeness
  });
}
export function removeAlert(uuid) {
  return {
    type: REMOVE_ALERT,
    payload: {
      uuid: uuid
    }
  };
}